import React, { useEffect } from 'react'
import { Linking, Platform } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { B2, Icon, Pressable, Stack, XStack, YStack } from '@zet/design-system'
import { HelpAndSupportType } from '@zet/utils/Constants'

import { useFreshchat } from '../../hooks/useFreshchat'
import { useNavigation } from '../../hooks/useNavigation'

type HelpDeskProps = {
  logo: string
  title: string
  subTitle: string
  type: string
  complaintsUrl?: string
  eventName?: string
  eventPayload?: object
}

export const HelpDesk = ({
  logo,
  title,
  subTitle,
  type,
  complaintsUrl,
  eventName,
  eventPayload,
}: HelpDeskProps) => {
  const { navigate } = useNavigation()
  const { showConversations } = useFreshchat()
  const onPress = () => {
    if (type === HelpAndSupportType.CALL_US) {
      let phoneNumber = '7417274072'

      if (Platform.OS === 'android') {
        phoneNumber = 'tel:${' + phoneNumber + '}'
      } else {
        phoneNumber = 'telprompt:${' + phoneNumber + '}'
      }
      Linking.openURL(phoneNumber)
    } else if (type === HelpAndSupportType.CHAT_WITH_US) {
      showConversations()
    } else if (type === HelpAndSupportType.RAISE_A_COMPLAINT) {
      navigate('WebViewScreen', {
        url: complaintsUrl,
      })
    } else if (type === HelpAndSupportType.FAQS) {
      navigate('FrequentlyAskedQuestions')
    }
  }

  useEffect(() => {
    publishEvent('screen_view', { screen_name: 'profile_help_support_faqs' })
  }, [])

  return (
    <>
      <Stack className=" mt-1 bg-[#FFFFFF]">
        <Pressable
          onPress={onPress}
          eventName={eventName}
          eventPayload={eventPayload}
        >
          <XStack className=" justify-between  p-3">
            <XStack className="">
              <Icon className="mt-2" size={24} type={logo}></Icon>
              <YStack className="ml-4">
                <B2 className="">{title}</B2>
                <B2 className="">{subTitle}</B2>
              </YStack>
            </XStack>

            <Icon className="mt-2" size={24} type="ArrowRight"></Icon>
          </XStack>
        </Pressable>
      </Stack>
    </>
  )
}
